import { CAT_NECESSARY, CAT_ANALYTICS } from "../constants.js";

const translation = {
  consentModal: {
    title: "اطلاعیه کوکی‌ها",
    description:
      "ما از کوکی‌های ضروری استفاده می‌کنیم تا اطمینان حاصل کنیم که این وب‌سایت به درستی کار می‌کند. همچنین از کوکی‌های اختیاری برای ردیابی استفاده می‌کنیم تا بفهمیم چگونه با سایت ما تعامل دارید. این کوکی‌های اختیاری فقط با رضایت شما تنظیم خواهند شد.",
    acceptAllBtn: "قبول همه",
    acceptNecessaryBtn: "رد همه",
    showPreferencesBtn: "مدیریت ترجیحات فردی",
  },
  preferencesModal: {
    title: "مدیریت ترجیحات کوکی",
    acceptAllBtn: "قبول همه",
    acceptNecessaryBtn: "رد همه",
    savePreferencesBtn: "قبول انتخاب فعلی",
    closeIconLabel: "بستن پنجره",
    sections: [
      {
        title: "استفاده از کوکی",
        description:
          "ما از کوکی‌ها برای پشتیبانی از عملکردهای اصلی این وب‌سایت و بهبود تجربه مرور شما استفاده می‌کنیم.",
      },
      {
        title: "کوکی‌های کاملاً ضروری",
        description: "این کوکی‌ها برای عملکرد صحیح وب‌سایت ضروری هستند، مانند احراز هویت کاربر.",
        linkedCategory: CAT_NECESSARY,
        cookieTable: {
          headers: { name: "نام", domain: "خدمت", description: "توضیحات", expiration: "انقضا" },
          body: [
            {
              name: "_care_leavers_social_hub_session",
              domain: "www.secure-messaging.co.uk",
              description: "کوکی تنظیم شده توسط پلتفرم جامعه دیجیتال برای احراز هویت کاربر.",
              expiration: "نشست",
            },
            {
              name: "CSRF-TOKEN",
              domain: "www.secure-messaging.co.uk",
              description: "کوکی تنظیم شده توسط پلتفرم جامعه دیجیتال برای احراز هویت کاربر",
              expiration: "نشست",
            },
            {
              name: "__cf_bm",
              domain: ".www.secure-messaging.co.uk",
              description:
                "این کوکی برای تشخیص بین انسان و ربات برای محافظت از وب‌سایت در برابر سوءاستفاده خودکار استفاده می‌شود. هیچ داده شخصی جمع‌آوری نمی‌شود.",
              expiration: "۳۰ دقیقه",
            },
          ],
        },
      },
      {
        title: "تحلیل",
        description:
          "کوکی‌های مورد استفاده برای تحلیل به جمع‌آوری داده‌ها کمک می‌کنند که به سرویس‌ها اجازه می‌دهد بفهمند کاربران چگونه با یک سرویس خاص تعامل دارند. این داده‌ها به بهبود محتوا و ایجاد ویژگی‌های بهتر کمک می‌کند که تجربه کاربر را بهبود می‌بخشد.",
        linkedCategory: CAT_ANALYTICS,
        cookieTable: {
          headers: { name: "نام", domain: "خدمت", description: "توضیحات", expiration: "انقضا" },
          body: [
            {
              name: "_ga",
              domain: "Google Analytics",
              description:
                'کوکی تنظیم شده توسط <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "پس از ۱۲ روز منقضی می‌شود",
            },
            {
              name: "_gid",
              domain: "Google Analytics",
              description:
                'کوکی تنظیم شده توسط <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "نشست",
            },
          ],
        },
      },
    ],
  },
};

const servicesLabel = "فعال‌سازی ذخیره‌سازی مرتبط با تحلیل‌ها مانند مدت بازدید.";

export { translation, servicesLabel };
